<template>
  <div>
    <b-field v-if="!disabled" grouped>
      <b-input
        v-model="newText"
        placeholder="Add new item"
        @keyup.enter.native="addItem"
      />
      <p class="control">
        <b-button type="is-primary" @click="addItem">Add</b-button>
      </p>
    </b-field>
    <b-table
      class="custom-draggable-table"
      :data="items"
      :mobile-cards="false"
      :bordered="true"
      :striped="true"
      :draggable="!disabled"
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
    >
      <b-table-column v-slot="props" label="#" width="60">
        {{ props.index + 1 }}
      </b-table-column>
      <b-table-column v-slot="props" label="Text">
        <b-input
          v-model="props.row.text"
          :disabled="disabled"
          @input="emitChange"
        />
      </b-table-column>
      <b-table-column v-slot="props" width="100" centered>
        <b-button
          v-if="!disabled"
          type="is-danger"
          size="is-small"
          icon-left="delete"
          @click="removeItem(props.index)"
        />
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "SortableTableList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newText: "",
      items: this.buildItems(this.value),
      draggedRow: null,
      dragOverRow: null,
    };
  },
  watch: {
    value: {
      handler(vals) {
        this.items = this.buildItems(vals);
      },
      deep: true,
    },
  },
  methods: {
    buildItems(vals = []) {
      return vals.map((val) => ({ text: val }));
    },
    emitChange() {
      this.$emit(
        "input",
        this.items.map((item) => item.text)
      );
    },
    addItem() {
      if (!this.newText.trim()) return;

      this.items.push({ text: this.newText });

      this.newText = "";

      this.emitChange();
    },
    removeItem(index) {
      this.items.splice(index, 1);

      this.emitChange();
    },
    dragstart(payload) {
      this.draggedRow = payload.index;
    },
    dragover(payload) {
      payload.event.preventDefault();
      this.dragOverRow = payload.index;
    },
    dragleave() {
      this.dragOverRow = null;
    },
    drop(payload) {
      const from = this.draggedRow;
      const to = payload.index;

      if (from === null || to === null || from === to) return;

      const movedItem = this.items[from];

      this.items.splice(from, 1);
      this.items.splice(to, 0, movedItem);

      this.draggedRow = null;
      this.dragOverRow = null;

      this.emitChange();
    },
  },
};
</script>

<style>
.custom-draggable-table tbody tr {
  cursor: move;
}

.custom-draggable-table input,
.custom-draggable-table textarea,
.custom-draggable-table button,
.custom-draggable-table .button {
  cursor: auto !important;
}
</style>
